import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlQueryService} from '../../../common/url-query/url-query.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CacProfilesApiService {

  constructor(private http: HttpClient) {}

  readonly cacProfilesUrl: string = 'cac/profile';
  readonly cacProfilesConfigurationUrl: string = 'configuration/cac';

  public getCacProfiles(params: object = {}): Observable<any> {
    const generatedCacProfilesUrl = UrlQueryService.addQueryParameters(this.cacProfilesUrl, params);

    return this.http.get(generatedCacProfilesUrl);
  }

  public getCacProfile(id: number): Promise<any> {
    return this.http.get(`${this.cacProfilesUrl}/${id}`).toPromise();
  }

  public addCacProfile(cacProfile: any): Promise<any> {
    return this.http.post(this.cacProfilesUrl, cacProfile).toPromise();
  }

  public editCacProfile(customer: any, id: number): Promise<any> {
    return this.http.put(`${this.cacProfilesUrl}/${id}`, customer).toPromise();
  }

  public deleteCacProfile(id: number): Promise<any>{
    return this.http.delete(`${this.cacProfilesUrl}/${id}`).toPromise();
  }

  public getCacProfilesConfiguration(): Observable<any> {
    return this.http.get(this.cacProfilesConfigurationUrl);
  }

  public editCacProfilesConfiguration(cacProfilesConfiguration): Promise<any> {
    return this.http.put(this.cacProfilesConfigurationUrl, cacProfilesConfiguration).toPromise();
  }
}
